import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ProductFinderResultPage from './productfinderresultpage/productfinderresultpage';
import IProductFinderResultPage from './productfinderresultpage/productfinderresultpage.d';

function hydrateProductFinderResultPage() {
    if (typeof window !== 'undefined' && typeof window.__PRELOADED_PRODUCT_FINDER_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_PRODUCT_FINDER_PAGE_STATE__)) as IProductFinderResultPage;
        delete window.__PRELOADED_PRODUCT_FINDER_PAGE_STATE__;
        const root = document.getElementById('ats_productfinderresultpage');

        ReactDOM.hydrate(
            <ProductFinderResultPage {...data} />,
            root
        );
    }
}

hydrateProductFinderResultPage();
